export default __webpack_public_path__ + "static/gantserif-medium-condensed-54815e88316d0179a4aae39738030240.woff2";